import { Button, ButtonProps } from '@fable/components'
import { CompChildren } from '@fable/types'
import { useDeeplinkModal } from 'components/app_deep_link_modal'
import { OpenDeeplinkModalProps } from 'components/app_deep_link_modal/types'

interface Props extends ButtonProps {
  children?: CompChildren
  options?: OpenDeeplinkModalProps
}

export const BookDetailDownloadAppCTA = ({
  className,
  children = 'Download the app',
  options,
  ...props
}: Props) => {
  const { openDeeplinkModal } = useDeeplinkModal()

  const modalProps: OpenDeeplinkModalProps = {
    hideSMS: true,
    description:
      'Curate lists, rate and review books, and meet fellow readers, only on the app.',
    hideAuth: true,
    ...options,
  }

  return (
    <Button
      className={className}
      onClick={() => openDeeplinkModal(modalProps)}
      {...props}
    >
      {children}
    </Button>
  )
}
